import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { UserContext } from '../../../contexts/UserContext';
import Merchant from '../../../domain/entities/Merchant';
import AdsBottom from '../../common/adsense/AdsBottom';
import Breadcrumbs from '../../common/breadcrumbs/Breadcrumbs';
import Button, { ButtonSize } from '../../common/buttons/Button';
import BaseLayoutMerchant, {
  Props as BaseLayoutProps,
} from '../../common/layouts/BaseLayoutMerchant';
import { Props as FooterProps } from '../../common/layouts/MerchantGlobalFooter';
import MerchantHeader from '../common/MerchantHeader';
import MerchantNav, { MerchantNavProps } from '../common/MerchantNav';
import MerchantStickyFooter from '../common/MerchantStickyFooter';
import * as $ from '../helper';
import css from './BaseTemplate.module.scss';

export type TemplateProps = MerchantNavProps;

interface Props
  extends BaseLayoutProps,
    TemplateProps,
    InjectedIntlProps,
    React.HTMLProps<{}> {
  merchant: Merchant;
  breadcrumbs?: Array<{ url: string; text: string }>;
  bookingPageIsBookable?: boolean;
}

/**
 * Templete component for merchant show & child page.
 */
const BaseTemplate = ({
  footerProps,
  merchant,
  breadcrumbs,
  bookingPageIsBookable,
  intl,
  ...props
}: Props) => {
  const userCtx = React.useContext(UserContext);
  const footerPropsWithMerchantCtx: FooterProps = {
    hideBlandContent: merchant.feature.isAdHiding && userCtx.auth.isLoggedIn,
    isMerchantStickyFooterExist: true,
    ...footerProps,
  };
  const canShowUpgradeButton = $.showOwnMerchantPageBy(userCtx.auth, merchant);

  return (
    <BaseLayoutMerchant
      className={css.BaseTemplate}
      footerProps={footerPropsWithMerchantCtx}
    >
      {!userCtx.request.isCoubicApp && breadcrumbs && (
        <Breadcrumbs
          breadcrumbs={breadcrumbs}
          className={css.BaseTemplate__Breadcrumbs}
        />
      )}
      <MerchantHeader
        className={css.BaseTemplate__Header}
        merchant={merchant}
        bookingPageIsBookable={bookingPageIsBookable}
      />
      <div id="pageContent" className={css.BaseTemplate__Body}>
        <MerchantNav
          booking_page_count={props.booking_page_count}
          post_count={props.post_count}
          product_count={props.product_count}
          merchant={merchant}
        />
        <div className={css.BaseTemplate__Content}>{props.children}</div>
      </div>
      {!merchant.feature.isAdHiding && !userCtx.request.isCoubicApp && (
        <div className={css.BaseTemplate__AdsSection}>
          <AdsBottom />
          {canShowUpgradeButton && (
            <div className={css.BaseTemplate__UpgradeSection}>
              <Button
                className={css.BaseTemplate__Button}
                isGhost={true}
                isFull={true}
                href={
                  '/subscriptions?utm_source=premium_upgrade&utm_medium=ads&utm_campaign=premium_upgrade'
                }
                buttonSize={ButtonSize.Medium}
              >
                {intl.formatMessage({
                  id: 'merchants.baseTemplate.upgradeButton',
                })}
              </Button>
            </div>
          )}
        </div>
      )}
      <MerchantStickyFooter
        merchant={merchant}
        bookingPageCount={props.booking_page_count}
        bookingPageIsBookable={bookingPageIsBookable}
      />
    </BaseLayoutMerchant>
  );
};

export default injectIntl(BaseTemplate);
